import api from "../../utils/apiUserTienda";

export const getPermisos = async () => {
  const res = await api.get("/api/tienda/permisos/obtener");
  return res.data; 
};

export const getPermisosByRol = async (rol_tienda_id) => {
  const res = await api.get(`/api/tienda/permisos/obtener/${rol_tienda_id}`);
  return res.data;
};

export const assignPermisosToRol = async (rol_tienda_id, permisos) => {
  const res = await api.post(`/api/tienda/permisos/asignar/${rol_tienda_id}`, { permisos });
  return res.data;
};